import { forwardRef, useEffect, useRef, useState } from "react";
import type React from "react";
import cn from "mcn";

export const InputAutoSize = forwardRef<HTMLInputElement, React.ComponentProps<"input"> & { outerClass?: string }>(
  function InputAutoSize({ outerClass, ...p }, ref) {
    "use no memo"; // FIXME: REACT-COMPILER - Error: Cannot access refs during render

    const outerRef = useRef<HTMLInputElement>(null);
    const innerRef = useRef<HTMLInputElement>(null);
    const [width, setWidth] = useState(0);

    const updateRef = useRef(() => void null);
    updateRef.current = () => {
      if (innerRef.current) setWidth(Math.max(innerRef.current.offsetWidth + 6, outerRef.current?.offsetWidth ?? 0));
    };

    useEffect(() => {
      if (!outerRef.current || !innerRef.current) return;
      const observer = new ResizeObserver(() => updateRef.current());
      observer.observe(outerRef.current);
      return () => observer.disconnect();
    }, []);

    // biome-ignore lint/correctness/useExhaustiveDependencies: We only want to update when p.value changes
    useEffect(() => {
      const timeout = setTimeout(() => updateRef.current(), 15);
      return () => clearTimeout(timeout);
    }, [p.value]);

    return (
      <div ref={outerRef} style={{ position: "relative" }} className={cn("relative", outerClass)}>
        <div ref={innerRef} style={{ opacity: 0, userSelect: "none" }}>
          0{p.value}
        </div>
        <input
          type="text"
          {...p}
          ref={ref}
          style={{
            width,
            position: "absolute",
            inset: 0,
            top: 0,
            left: 0,
            margin: 0,
            ...p.style,
          }}
        />
      </div>
    );
  },
);
